module.exports = __webpack_public_path__ + "static/media/slide1.be45cfd9.png";